import { axios, handleError } from '../axios';

export const getRelatedPosts = (params) => {
  return new Promise((resolve, reject) => {
    axios
      .get('posts/related/', { params })
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
          reject();
        }
      })
      .catch((e) => {
        handleError(e);
        reject();
      });
  });
};
